"use strict";
/**
 * Weekly Report API Types
 *
 * API request/response types for the weeklyReport tRPC router.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextReportDateResponseSchema = void 0;
const zod_1 = require("zod");
// ============================================================================
// GET NEXT REPORT DATE
// ============================================================================
exports.NextReportDateResponseSchema = zod_1.z.object({
    /** ISO date string (YYYY-MM-DD) of the next report, or null if not yet computable. */
    nextReportDate: zod_1.z.string().nullable(),
});
//# sourceMappingURL=weeklyReport.js.map